const sensor = document.getElementById('sensor');
const el = document.querySelector("#wrapper-navbar")
const logo = document.getElementById("eWKcrxLS1p91")
const primaryMenu = document.getElementById('mega-menu-primary');
const player = logo ? logo.svgatorPlayer : {};
let expandedByClick = false;
let playerPosition = 'start';
const navBreakpoint = parseInt( window.getComputedStyle(document.documentElement).getPropertyValue('--bs-breakpoint-' + 'nav'), 10 )

function svgPlayer( direction ){
	if( direction == 'play' && playerPosition == 'start'){
		player.play()
		playerPosition = 'end'
	}else if( direction == 'reverse' && playerPosition == 'end' ){
		player.reverse()
		playerPosition = 'start'
	}
}
const observer = new IntersectionObserver(
  ([e]) => {
	  if( ! primaryMenu.classList.contains('mega-toggle-on') ){ //Don't collapse the header if the megamenu is open
	  	el.classList.toggle("is-pinned", e.intersectionRatio < .5)
	  	//e.intersectionRatio < .5 ? player.play() : player.reverse();
	  	if( e.intersectionRatio <= .5 && ! expandedByClick ){
		  	el.classList.remove("sticky-expanded");
			svgPlayer('play')
	  	}
		if( e.intersectionRatio > .5 ){
			expandedByClick = false;
			svgPlayer('reverse')
		}
  	}
  },
  { threshold: [.5] }
);
if( sensor ){
	observer.observe(sensor);
}

jQuery(function($) {
	$('li.mega-menu-item').on('close_panel', function() {
		observer.unobserve(sensor);
		observer.observe(sensor);
	})
});

const stickyToggle = document.getElementById('mega-sticky-toggle-block')
const stickyToggleClose = document.getElementById('mega-sticky-toggle-block-close')
if( stickyToggle ){
stickyToggle.addEventListener('click', e => {
	if( window.innerWidth >= navBreakpoint ){
		expandedByClick = true;
		el.classList.add('sticky-expanded');
		svgPlayer('reverse')
	}
});
}
if( stickyToggleClose ){
stickyToggleClose.addEventListener('click', e=> {
	el.classList.remove('sticky-expanded');
	expandedByClick = false;
	svgPlayer('play')
});
}
